import { render } from "./ProsSection.vue?vue&type=template&id=43486b86&scoped=true"
import script from "./ProsSection.vue?vue&type=script&lang=js"
export * from "./ProsSection.vue?vue&type=script&lang=js"

import "./ProsSection.vue?vue&type=style&index=0&id=43486b86&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43486b86"]])

export default __exports__